<template>
    <transition name="fade" @after-enter="showModalDialog = true">
        <div v-show="visible" class="ca-modal modal media-upload-modal" :class="{'is-visible': visible}" tabindex="-1" role="dialog" aria-labelledby="uploadModalLabel" :aria-hidden="!visible">
            <transition name="modal" enter-active-class="animated slideInDown" leave-active-class="animated slideOutUp">
                <div v-show="showModalDialog" class="modal-dialog modal-xl">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="uploadModalLabel">Upload media</h4>
                            <button type="button" class="close" aria-hidden="true" @click="doDismiss"><i class="fa fa-times"></i></button>
                        </div>
                        <div class="modal-body">
                            <media-upload />
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default waves-effect" @click="doDismiss"><i class="fa fa-times"></i> Cancel</button>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import MediaUpload from '@/components/media/upload';

export default {
    name: 'MediaUploadModal',
    components: {
        MediaUpload
    },
    data() {
        return {
            showModalDialog: false,
        }
    },
    computed: {
        ...mapGetters({
            processedItems: 'getMediaProcessedItems',
            visible: 'getMediaUploadModalShow',
        }),
    },
    methods: {
        ...mapActions([
            'hideMediaUploadModal'
        ]),
        doDismiss() {
            this.showModalDialog = false;
            setTimeout(() => {
                this.hideMediaUploadModal();
                //this.$refs.pond.removeFiles();
            }, 400);
        },
        onCloseUploadModal() {
            this.doDismiss();
        },
    }
}
</script>

<style lang="scss">

</style>
